import React from "react";
import "./zeropackagemodal.css";
import axios from "axios";

function ZeroPackageModal({ isVisible, onClose, onPackageAction }) {
  if (!isVisible) return null;
  const token = localStorage.getItem("authToken"); // get JWT from storage
  // Function to handle API calls based on the action (backup, retrieve, zero)
  const handlePackageAction = (action) => {
    let url = "";

    switch (action) {
      case "backup":
        url = "  https://quatdashboard.com:8084/api/mainTable/backup";
        break;
      case "retrieve":
        url = "  https://quatdashboard.com:8084/api/mainTable/restore";
        break;
      case "zero":
        if (
          !window.confirm(
            "Are you sure you want to reset all package for Server1?",
          )
        ) {
          return;
        }
        url = "  https://quatdashboard.com:8084/api/mainTable/resetall";
        break;

      case "zeros2":
        if (
          !window.confirm(
            "Are you sure you want to reset all package for Server2?",
          )
        ) {
          return;
        }
        url = "  https://quatdashboard.com:8084/api/mainTable/resetall2";
        break;

      case "zeroflat":
        if (
          !window.confirm(
            "Are you sure you want to reset package for Flattrade Server-1 Users?",
          )
        ) {
          return;
        }
        url = "  https://quatdashboard.com:8084/api/mainTable/resetflattrade";
        break;

      case "zeroflats2":
        if (
          !window.confirm(
            "Are you sure you want to reset package for Flattrade Server-2 Users?",
          )
        ) {
          return;
        }
        url = "  https://quatdashboard.com:8084/api/mainTable/resetflattrade2";
        break;
      default:
        return;
    }

    // Call the respective API based on action
    // axios
    //   .post(url)
    //   .then((response) => {
    //     console.log(response.data); // Log the response or handle success
    //     onPackageAction(action); // You can call the passed callback if needed
    //     alert(
    //       `${
    //         action.charAt(0).toUpperCase() + action.slice(1)
    //       } action completed successfully!`
    //     );
    //   })
    //   .catch((error) => {
    //     console.error("There was an error!", error); // Handle the error
    //     alert(`Failed to perform ${action} action.`);
    //   });
    axios
      .post(
        url,
        {}, // empty body if not required
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      )
      .then((response) => {
        console.log(response.data); // Log the response or handle success
        onPackageAction(action); // You can call the passed callback if needed
        alert(
          `${
            action.charAt(0).toUpperCase() + action.slice(1)
          } action completed successfully!`,
        );
      })
      .catch((error) => {
        console.error("There was an error!", error); // Handle the error
        alert(`Failed to perform ${action} action.`);
      });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Package Actions</h2>
        <span className="close" onClick={onClose}>
          &times;
        </span>
        <div className="btn-container">
          <button
            className="btn-package"
            onClick={() => handlePackageAction("backup")}
          >
            Backup
          </button>
          <button
            className="btn-package"
            onClick={() => handlePackageAction("zero")}
          >
            Zero
          </button>

          <button
            className="btn-package"
            onClick={() => handlePackageAction("zeros2")}
          >
            Zero-S2
          </button>

          <button
            className="btn-package"
            onClick={() => handlePackageAction("retrieve")}
          >
            Retrieve
          </button>

          <button
            className="btn-package"
            onClick={() => handlePackageAction("zeroflat")}
          >
            Zero FlatTrade
          </button>

          <button
            className="btn-package"
            onClick={() => handlePackageAction("zeroflats2")}
          >
            Zero FlatTrade-S2
          </button>
        </div>
      </div>
    </div>
  );
}

export default ZeroPackageModal;
